import { createContext, useContext } from "react";

/**
 * Context for field-level security.
 * Wrap your form with <FieldSecurityProvider> to avoid passing
 * startingPoint, entity, and bookingsFieldsEnabled to every field.
 */
const FieldSecurityContext = createContext({
  entity: "",
  startingPoint: "",
  bookingsFieldsEnabled: true,
});

/**
 * @param {string}  entity               - e.g. "BioAliases"
 * @param {string}  startingPoint        - starting point passed to hasCheckSecurity
 * @param {boolean} bookingsFieldsEnabled - master edit toggle
 */
export const FieldSecurityProvider = ({
  entity,
  startingPoint,
  bookingsFieldsEnabled,
  children,
}) => (
  <FieldSecurityContext.Provider
    value={{ entity, startingPoint, bookingsFieldsEnabled }}
  >
    {children}
  </FieldSecurityContext.Provider>
);

/** Returns context values; throws if used outside a provider. */
export const useFieldSecurity = () => {
  const ctx = useContext(FieldSecurityContext);
  if (!ctx) {
    throw new Error("useFieldSecurity must be used inside <FieldSecurityProvider>");
  }
  return ctx;
};

export default FieldSecurityContext;
